import { useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Form, Input, message, Tooltip } from "antd";
import { ButtonsRow } from "Components/Form/ButtonsRow";
import { ModalComponentProps } from "Components/General/Modal/ModalContext";
import { I18N_NS } from "Config/i18n";
import { useTranslation } from "react-i18next";
import { dirnameCharValidator } from "utils/inputValidation";

interface EditProjectGroupNameModalProps extends ModalComponentProps {
  currentName: string;
  projectId: number;
  updateData: (id: number, payload: API_PGAdminProjectChanges) => Promise<void>;
  updateTable?: () => void;
}

export const EditProjectGroupNameModal = ({
  currentName,
  projectId,
  updateData,
  hideModal,
}: EditProjectGroupNameModalProps) => {
  const { t } = useTranslation([I18N_NS.ADMIN, I18N_NS.PROJECT]);
  const handleFinish = useCallback(
    async (value) => {
      await updateData(projectId, { newProjectName: value?.newProjectName });
      message.success(t("Success"));
      hideModal();
    },
    [updateData, projectId, t, hideModal]
  );

  const projectNameValidator = useCallback((_: unknown, value: string) => dirnameCharValidator(_, value, t), [t]);
  return (
    <Form onFinish={handleFinish}>
      <Form.Item
        name="newProjectName"
        label={t("Name")}
        rules={[
          { required: true, message: t("This field is required") },
          { required: true, validator: projectNameValidator },
        ]}
        initialValue={currentName}
      >
        <Input />
      </Form.Item>
      <ButtonsRow justify="space-between">
        <Tooltip
          title={t("Unallowed characters: {{unallowedChars}}", {
            unallowedChars: t('/\\:*?"<>|@&%'),
            interpolation: { escapeValue: false },
          })}
        >
          <span>
            <FontAwesomeIcon icon={["far", "info-circle"]} color="#0fb9b1" fixedWidth={true} />
          </span>
        </Tooltip>
        <Button htmlType="submit" type="primary">
          {t("Edit")}
        </Button>
      </ButtonsRow>
    </Form>
  );
};
